import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  LinearProgress
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const AutoLogoutWarning = ({ open, onCancel, onLogout }) => {
  const { t } = useTranslation();
  const [countdown, setCountdown] = useState(60); // 60 Sekunden Countdown

  useEffect(() => {
    if (!open) {
      setCountdown(60);
      return;
    }

    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          // Zeit abgelaufen - Auto-Logout
          onLogout();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [open, onLogout]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const progressValue = ((60 - countdown) / 60) * 100;

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      onClose={() => {}} // Verhindert Schließen durch Klick außerhalb
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 2,
        backgroundColor: 'warning.light',
        color: 'warning.contrastText'
      }}>
        <WarningAmberIcon />
        {t('admin.passwordManagement.autoLogout.warning.title')}
      </DialogTitle>
      
      <DialogContent sx={{ pt: 3 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant="body1">
            {t('admin.passwordManagement.autoLogout.warning.message')}
          </Typography>
          
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 2 }}>
            <Typography variant="h6" color="error" align="center">
              {formatTime(countdown)}
            </Typography>
            <LinearProgress 
              variant="determinate" 
              value={progressValue}
              color="error"
              sx={{ height: 8, borderRadius: 4 }}
            />
          </Box>
          
          <Typography variant="body2" color="text.secondary" align="center">
            {t('admin.passwordManagement.autoLogout.warning.instruction')}
          </Typography>
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button
          className="button"
          onClick={onCancel}
          disabled={countdown === 0}
        >
          {t('admin.passwordManagement.autoLogout.warning.stayLoggedIn')}
        </Button>
        <Button
          className="button-cancel"
          onClick={onLogout}
        >
          {t('admin.passwordManagement.autoLogout.warning.logoutNow')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AutoLogoutWarning;
